import React, { ReactElement, useEffect, useState } from 'react';
import Lang from '@lang/en';
import SuccessMessage from '@app/common/SuccessMessage';
import { NewPlusIcon, UploadCloudIcon } from '@root/src/assets/images';
import FileUploadS3 from '../s3/FileUploadS3';
import { ErrorLabel } from '@designSystem/dropDown/styled';
import useWindowWidth from '@root/src/app/common/useWindowWidth';
import {
  StyledButton,
  UploadContainer,
  UploadMobileButtonContainer,
} from './styles';
import { ParagraphLarge } from '@designSystem/typings';
import styled from 'styled-components';

interface PropsI {
  orderId: number;
  onImageUploaded: (fileName: string) => void;
}

const AbsoluteSuccessMessage = styled(SuccessMessage)`
  position: absolute;
`;

const AbsoluteErrorLabel = styled(ErrorLabel)`
  position: absolute;
`;

const CustomButton = (
  <StyledButton
    data-testid="healthcheck-order-add-results-add-scan"
    type="tertiary"
    label={Lang.healthCheckAddResultsAddScanText}
    icon={<NewPlusIcon />}
  />
);

const UploadMobileButton = () => (
  <UploadMobileButtonContainer>
    <UploadCloudIcon />
    <ParagraphLarge color="darkGrey">
      {Lang.healthCheckResultMobileUploadButtonLabel}
    </ParagraphLarge>
  </UploadMobileButtonContainer>
);

const ResultImageUpload = ({
  orderId,
  onImageUploaded,
}: PropsI): ReactElement => {
  const initState: {
    previewUrl: string;
    errorMsg: string;
    successMsg: string;
    timeoutId: Timeout | null;
  } = {
    previewUrl: '',
    errorMsg: '',
    successMsg: '',
    timeoutId: null,
  };
  const [state, setState] = useState(initState);
  const uploadFinish = async (
    fileName: string,
    previewUrl: string
  ): Promise<void> => {
    try {
      await onImageUploaded(previewUrl);
      const timeoutId = setTimeout(clearMessage, 5000);
      setState((state) => ({
        ...state,
        successMsg: Lang.uploadSuccessMsg,
        timeoutId,
        previewUrl,
      }));
    } catch (error) {
      const timeoutId = setTimeout(clearMessage, 5000);
      setState((state) => ({
        ...state,
        errorMsg: Lang.apiRequestFailed,
        timeoutId,
      }));
    }
  };

  const { isMobileView } = useWindowWidth();

  useEffect(() => {
    return (): void => {
      state.timeoutId && clearInterval(state.timeoutId);
    };
  }, [state.timeoutId]);

  const clearMessage = (): void => {
    setState((state) => ({ ...state, errorMsg: '', successMsg: '' }));
  };

  const MobileButton = <UploadMobileButton />;

  return (
    <UploadContainer isMobileView={isMobileView}>
      <FileUploadS3
        accept="image/*"
        orderId={orderId}
        onUploadFinishProp={uploadFinish}
        acl="private"
        CustomButton={isMobileView ? MobileButton : CustomButton}
      />
      <AbsoluteErrorLabel>
        {state.errorMsg ? state.errorMsg : ''}
      </AbsoluteErrorLabel>
      {state.successMsg && (
        <AbsoluteSuccessMessage>{state.successMsg}</AbsoluteSuccessMessage>
      )}
    </UploadContainer>
  );
};
export default ResultImageUpload;
